// extracted by mini-css-extract-plugin
export default {"root":"MessagesSection_root__1exh0","title":"MessagesSection_title__9mw33","list":"MessagesSection_list__KEH-c"};